import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <button style={{
      "height": "3.5rem",
      "width": "7rem"
    }}><a className="btn btn-success" style={{
        "color": "#08789e"
      }} href="/Caio_Fleury_CV.pdf" target="_blank"><b>Download CV</b></a></button><br /><br />
I'm an IT professional with proven experience in Software Architecture, Data Science, Analytics, Back end, Web Dev, Software Engineering, Project & Database Management.
I have strong technical and soft skills, enabling me to work with a wide range of clients and teams. I am eager to expand my knowledge and be challenged in order to further improve.
My greatest passion is using my skills to turn problems into technological solutions that benefit people and organisations.
    <br />
    <p><i>"I strongly recommend Caio Fleury as an excellent software engineer with strong technical and soft skills."</i> — <a href="https://www.linkedin.com/in/denis-kolev-8506a173/" target="_blank" style={{
        "color": "#00a5dd"
      }}>Denis Kolev</a></p>
    <p><i>"I highly recommend Caio as a responsible and initiative worker."</i> — <a href="https://www.linkedin.com/in/alexey-utkin-87752215a/" target="_blank" style={{
        "color": "#00a5dd"
      }}>Alexey Utkin</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      